import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel , Autocomplete, Typography, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useUbigeoStore } from "../../../hooks/useUbigeoStore";
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import { useStockProductStore } from "../../../hooks/useStockProductStore";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

type Values = {
    idcountry: number,
    iddepartment: number,
    idprovince: number,
    iddistrict: number,
    idcompany: number,
    status: string,
}

const warehouses = [
    {id: 1, name: 'Shalom Express', address: 'av salaverry #776'}
]

export const ModalProductAvailability: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, storeSelected, product, clearState } = props;

    const { getCountries, getDepartments, getProvinces, getDistricts } = useUbigeoStore();
    const { getProductAvailability } = useStockProductStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);

    const [warehouses, setWareHouses] = useState<any>([]);
    const [countries, setCountries] = useState<any>([]);
    const [countryselected, setCountrySelected] = useState<any>('');
    const [departments, setDepartments] = useState<any>([]);
    const [departmentselected, setDepartmentSelected] = useState<any>('');
    const [provinces, setProvinces] = useState<any>([]);
    const [provinceselected, setProvinceSelected] = useState<any>('');
    const [districts, setDistricts] = useState<any>([]);
    const [districtselected, setDistrictSelected] = useState<any>('');

    console.log(warehouses)

    const [data, setData] = useState<Values>({
        idcountry: storeSelected ? storeSelected.idcountry :'',
        iddepartment: storeSelected ? storeSelected.iddepartment :'',
        idprovince: storeSelected ? storeSelected.idprovince :'',
        iddistrict: storeSelected ? storeSelected.iddistrict :'',
        idcompany: storeSelected ? storeSelected.idcompany :'',
        status: storeSelected ? storeSelected.status :'1',
    });

    useEffect(() => {
        getCountriesApi();
        getavailability();
    },[])

    const getavailability = async(iddistrict='') => {
        try {
            setLoadingdata(true);
            const response = await getProductAvailability({idproduct:product?.id, iddistrict: iddistrict});
            if(!response){
                setWareHouses([]);
                setLoadingdata(false);
                return false;
            }else{
                setWareHouses(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getCountriesApi = async() => {
        try {
            setLoadingdata(true);
            const response = await getCountries();
            if(!response){
                setCountries([]);
                setLoadingdata(false);
                return false;
            }else{
                setCountries(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDepartmentsApi = async(idcountry='') => {
        try {
            setLoadingdata(true);
            const response = await getDepartments('', idcountry);
            if(!response){
                setDepartments([]);
                setLoadingdata(false);
                return false;
            }else{
                setDepartments(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getProvincesApi = async(iddeparment='') => {
        try {
            setLoadingdata(true);
            const response = await getProvinces('', iddeparment);
            if(!response){
                setProvinces([]);
                setLoadingdata(false);
                return false;
            }else{
                setProvinces(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }
    const getDistrictsApi = async(idprovince='') => {
        try {
            setLoadingdata(true);
            const response = await getDistricts('', idprovince);
            if(!response){
                setDistricts([]);
                setLoadingdata(false);
                return false;
            }else{
                setDistricts(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.idcountry) errors.idcountry = "el campo es requerido";
        if(!values.iddepartment) errors.iddepartment = "el campo es requerido";
        if(!values.idprovince) errors.idprovince = "el campo es requerido";
        if(!values.iddistrict) errors.iddistrict = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        getavailability(districtselected?.id);
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="sm" >
            <ModalHeader
                text={'Recoge en un punto'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
                icon={<StoreMallDirectoryOutlinedIcon/>}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'10px'}}>
                                    <Grid item container xs={12} spacing={2}>

                                        {/* <Grid item xs={12} md={12}>
                                            <FormLabel>País:</FormLabel>
                                            <Autocomplete
                                                id="idcountry"
                                                size="small"
                                                value={!!countryselected ? countryselected : null}
                                                options={countries || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idcountry && touched.idcountry ? true : false}
                                                        helperText={errors.idcountry && touched.idcountry ? errors.idcountry : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setCountrySelected(newValue)
                                                    setFieldValue('idcountry', newValue ? newValue.id : "");
                                                    if(newValue) getDepartmentsApi(newValue.id)

                                                    setDepartmentSelected("");
                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Región:</FormLabel>
                                            <Autocomplete
                                                id="iddepartment"
                                                size="small"
                                                value={!!departmentselected ? departmentselected : null}
                                                options={departments || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddepartment && touched.iddepartment ? true : false}
                                                        helperText={errors.iddepartment && touched.iddepartment ? errors.iddepartment : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDepartmentSelected(newValue)
                                                    setFieldValue('iddepartment', newValue ? newValue.id : "");
                                                    if(newValue) getProvincesApi(newValue.id)

                                                    setProvinceSelected("");
                                                    setDistrictSelected("");
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Provincia:</FormLabel>
                                            <Autocomplete
                                                id="idprovince"
                                                size="small"
                                                value={!!provinceselected ? provinceselected : null}
                                                options={provinces || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.idprovince && touched.idprovince ? true : false}
                                                        helperText={errors.idprovince && touched.idprovince ? errors.idprovince : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setProvinceSelected(newValue)
                                                    setFieldValue('idprovince', newValue ? newValue.id : "");
                                                    if(newValue) getDistrictsApi(newValue.id)

                                                    setDistrictSelected("");
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <FormLabel>Comuna:</FormLabel>
                                            <Autocomplete
                                                id="iddistrict"
                                                size="small"
                                                value={!!districtselected ? districtselected : null}
                                                options={districts || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small"
                                                        error={errors.iddistrict && touched.iddistrict ? true : false}
                                                        helperText={errors.iddistrict && touched.iddistrict ? errors.iddistrict : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setDistrictSelected(newValue)
                                                    setFieldValue('iddistrict', newValue ? newValue.id : "");
                                                }}
                                            />
                                        </Grid> */}
                                        {
                                            warehouses && warehouses.length > 0 && (
                                                <>
                                                    <Grid item xs={12} sx={{marginTop:'15px'}}>
                                                        <FormLabel>{`${warehouses?.length} Punto(s) de retiro disponible`}</FormLabel>
                                                    </Grid>
                                                    {
                                                        warehouses?.map((store)=>(
                                                            <Grid item xs={12} >
                                                                <Grid display='flex' alignItems='center' sx={{border:'solid 1px #bfbfbf', marginTop:'10px', padding:'10px'}}>
                                                                    <Grid>
                                                                        <StoreMallDirectoryOutlinedIcon sx={{fontSize:'50px', color:'#333'}}/>
                                                                    </Grid>
                                                                    <Grid display='flex' sx={{marginLeft: '8px', flexDirection: 'column'}}>
                                                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '18px',color:'#333' }}>
                                                                            {store.name}
                                                                        </Typography>
                                                                        <Typography sx={{ fontSize: '16px'}}>
                                                                            {store.address}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        ))
                                                    }
                                                    
                                                </>
                                            )
                                        }
                                        {
                                            !loadingdata && warehouses.length == 0 && (
                                                <Grid item xs={12}>
                                                    <Grid display='flex' alignItems='center' sx={{border:'solid 1px #f0bebe', marginTop:'10px', padding:'10px', backgroundColor: '#f0bebe'}}>
                                                        <LocationOnOutlinedIcon sx={{fontSize:'40px', color:'#333'}}/>
                                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '18px', color:'#333', marginLeft:'10px' }}>
                                                            {'No disponible en el punto seleccionado'}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                        {
                                            loadingdata && (
                                                <Grid item xs={12}>
                                                    <Grid display='flex' alignItems='center' sx={{marginTop:'10px', padding:'10px'}}>
                                                        <Typography sx={{ fontSize: '16px', color:'#333', marginLeft:'10px' }}>
                                                            {'Buscando puntos de retiro...'}
                                                        </Typography>
                                                        <CircularProgress color="inherit" size={12} sx={{ color: 'black', marginLeft: "10px" }} />
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                        
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    districtselected ? (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loadingdata}
                                            clearState={clearState}
                                        />
                                    ) : (
                                        <ModalFooter 
                                            buttonType="submit"
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}